var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 19.5C9.02804 18.9434 10.7017 17.6823 12.021 15.7107C13.3403 13.739 14 11.5483 14 9.14444V3.34793L7 0.5L0 3.34793V9.14444C0 11.5542 0.659658 13.739 1.97897 15.7107C3.29829 17.6823 4.97196 18.9434 7 19.5ZM7 17.5047C5.48442 16.9836 4.23053 15.9356 3.23832 14.3666C2.24611 12.7976 1.75 11.0569 1.75 9.13852V4.65051L7 2.51309L12.25 4.65051V9.13852C12.25 11.0569 11.7539 12.7976 10.7617 14.3666C9.76947 15.9356 8.51558 16.9777 7 17.5047Z",
    fill: "#47474A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.d0d5a92226162616692a20394c725c16.svg";
export { ForwardRef as ReactComponent };